import { render, staticRenderFns } from "./NavigationUserMenu.vue?vue&type=template&id=19f83fea&"
import script from "./NavigationUserMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports